import { getCookieValue, setCookie } from './index';
import { Bid2Void } from '@api/endpoints';

export async function extractOShopCookie (): Promise<any> {
    let OShop: any = getCookieValue('oshop');
    let VOId;

    if (!OShop) {
        OShop = 'queryparams||b_id||1791||queryparams||shopid||2653';
        setCookie('testCookie', OShop);
    }

    const OShopComponents = OShop.split('queryparams||');

    for (const component of OShopComponents) {
        const splits = component.split('||');

        if (splits[0] === 'b_id') {
            VOId = await getBidMappingValue(splits[1]);
        }

    }

    if (!VOId) {
        VOId = '33333946';
    }

    return VOId;

}

async function getBidMappingValue (bId: string): Promise<any> {
    const bid2void = await Bid2Void.get({});

    if (bid2void.getResponse()) {
        for (const item of bid2void.getResponse()) {
            if (bId === item.bid) {
                return parseInt(item.void, 10);
            }
        }
    }

    return '';
}

setTimeout(() => {
    Bid2Void.get({});
}, 5000);



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/extract-oshop-cookie.ts